// Socket reconnect backoff with jitter, for the LiveSocket in app.js.
//
// Phoenix's default steps are fixed (10, 50, 100 … 2000ms, then 5s forever),
// so when a deploy drops every panel at the same instant they all retry at the
// same instants too, and whichever attempt finds the new server up lands on it
// all at once: each rejoin is a LiveView mount and a Wavebox auth call. Every
// step here is a random point in a window instead, so those reconnects spread
// out. The first window stays under LiveView's 500ms `disconnectedTimeout`, so
// an ordinary blip still reconnects before the "reconnecting" state shows; the
// steady state (5-10s) spreads a longer outage's recovery over five seconds.
export const RECONNECT_WINDOWS_MS = [[0, 450], [500, 1500], [1000, 3000], [2000, 5000]]
export const STEADY_WINDOW_MS = [5000, 10000]

/**
 * How long to wait before reconnect attempt `tries` (1-based), as Phoenix's
 * `reconnectAfterMs` option expects.
 * @param {number} tries - The attempt about to be scheduled, from 1.
 * @param {() => number} [random] - A source in [0, 1); tests pin it.
 * @returns {number} Milliseconds to wait.
 */
export function reconnectAfterMs (tries, random = Math.random) {
  const [min, max] = RECONNECT_WINDOWS_MS[tries - 1] || STEADY_WINDOW_MS
  return min + Math.floor(random() * (max - min))
}
